import axios from 'axios';

import { setAuthCookie } from 'services/authService';
import { UserHistoricalFormDataItem } from 'interfaces/components/savedUserData/UserHistoricalFormDataItem';

export const getHistoricalCompsData = async () => {
  await setAuthCookie();

  return new Promise<UserHistoricalFormDataItem[]>((resolve, reject) => {
    axios
      // .get('/mockData/userHistoricalFormData.json')
      .get('/api/getUserHistoricalFormData')
      .then(response => {
        resolve(response.data.data);
      })
      .catch(error => {
        reject(error);
      });
  });
};
